<template>
    <div>
        <v-dialog v-model="$store.getters.bookInfoDialog"
                  @click:outside="closeDialog"
                  max-width="900">

            <v-card>

                <v-card-title class="mb-3 headline secondary primary--text">
                    <h5 class="pr-4">Πληροφορίες Βιβλίου:</h5>
                    <v-chip outlined color="primary">{{book.title}}</v-chip>
                    <v-spacer/>
                    <v-icon color="primary" @click="closeDialog">close</v-icon>
                </v-card-title>

                <v-card-text style="background-color: #BDC9D2">

                    <v-row justify="space-around">
                        <v-col cols="2">
                            <v-chip outlined color="secondary"> <h5>Εξώφυλλο </h5> <v-icon @click="showBook(1)" color="secondary"> visibility</v-icon></v-chip>
                        </v-col>

                        <v-col cols="2">
                            <v-chip outlined color="secondary"> <h5>Οπισθόφυλλο </h5> <v-icon @click="showBook(2)" color="secondary"> visibility</v-icon></v-chip>
                        </v-col>

                        <v-col cols="3">
                            <v-chip outlined color="secondary"> <h5>Πίνακας Περιεχομένων </h5> <v-icon @click="showBook(3)" color="secondary"> visibility</v-icon></v-chip>
                        </v-col>

                        <v-col cols="3">
                            <v-chip outlined color="secondary"> <h5>Ενδεικτικό Απόσπασμα </h5> <v-icon @click="showBook(4)" color="secondary"> visibility</v-icon></v-chip>
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col cols="4">
                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Κωδικός Βιβλίου στον Εύδοξο </v-list-item-title>
                                    <v-list-item-subtitle>{{book.id}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Συγγραφείς </v-list-item-title>
                                    <v-list-item-subtitle>{{book.authors}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Αριθμός Έκδοσης </v-list-item-title>
                                    <v-list-item-subtitle>{{book.editionNumber}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Έτος Τρέχουσας Έκδοσης </v-list-item-title>
                                    <v-list-item-subtitle>{{book.publicationYear}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > ISBN </v-list-item-title>
                                    <v-list-item-subtitle>{{book.isbn}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Τύπος</v-list-item-title>
                                    <v-list-item-subtitle>{{returnBookType(book.type)}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-col>

                        <v-col cols="8">

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Διαθέτης (Εκδότης)</v-list-item-title>
                                    <v-list-item-subtitle>{{book.publisherName}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Εκδόσεις </v-list-item-title>
                                    <v-list-item-subtitle>{{book.editorialHouse}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Δέσιμο </v-list-item-title>
                                    <v-list-item-subtitle>{{book.binding}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Διαστάσεις</v-list-item-title>
                                    <v-list-item-subtitle>{{book.dimensions}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Αριθμός Σελίδων</v-list-item-title>
                                    <v-list-item-subtitle>{{book.pages}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title > Ιστοσελίδα Βιβλίου</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <a style="color: darkslategrey" :href=book.linkToPublisher target="_blank">Εδώ</a>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>


                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import utils from '../utilities';
	export default {
		name: "BookInfoDialog",
        data: () => ({
		}),

		props: {
			book: Object
		},

		methods: {
			closeDialog(){
                this.$store.commit('setBookInfoDialog', false);
            },

			showBook(cover) {
				document.activeElement.blur();

				if (cover === 1 && this.book.pathToCover != null) {
					var url = this.book.pathToCover;
					window.open(utils.containsPathToBook(url, '_blank'));
				} else if (cover === 2 && this.book.pathToBackcover != null) {
					var url = this.book.pathToBackcover;
					window.open(utils.containsPathToBook(url, '_blank'));
				} else if (cover === 3 && this.book.pathToTOC != null) {
					var url = this.book.pathToTOC;
					window.open(utils.containsPathToBook(url, '_blank'));
				} else if (cover === 4 && this.book.pathToChapter != null) {
					var url = this.book.pathToChapter;
					window.open(utils.containsPathToBook(url, '_blank'));
				} else {
					if (this.book.pathToFile != null) {
						var url = this.book.pathToFile;
						window.open(utils.containsPathToBook(url, '_blank'));
					}
				}
			},

			returnBookType(type){
				if(type === 'Published') {
					return 'Σύγγραμμα'
				}
				else if(type === 'eBook') {
					return 'Ηλεκτρονικό Βιβλίο'
				}
				else if(type === 'ProfessorNotes') {
					return 'Δωρεάν Ηλεκτρονικό Βοήθημα / Σημειώσεις'
				}
				else if(type === 'UniversityPress') {
					return 'Πανεπιστημιακή Έκδοση'
				}
				else if(type === 'Free') {
					return 'Δωρεάν Βιβλίο'
				}else {
					return '--';
				}
			},
		},
	}
</script>

<style scoped>

</style>